export const DEFAULT_PERMISSION: Permission = {
  // contract_view_all: false,
  // contract_view_part: false,
  // contract_create: false,
  // contract_edit: false,
  // contract_delete: false,
  // contract_approve_change: false,
  // kpi_location_create: false,
  // kpi_location_edit: false,
  // kpi_location_delete: false,
  // kpi_employee_create: false,
  // kpi_employee_edit: false,
  // kpi_employee_delete: false,
  // kpi_display_all: false,
  // kpi_display_part: false,
  // kpi_sales_display: false,
  // master_data: false,
  // class_display_all: false,
  // class_display_part: false,
  // class_create: false,
  // class_edit: false,
  // class_delete: false,
  // supplies_display: false,
  // supplies_create: false,
  // supplies_edit: false,
  // supplies_delete: false,
  // attendance_display: false,
  // attendance_create: false,
  // attendance_edit: false,
  // attendance_delete: false,
  // homework_display: false,
  // homework_create: false,
  // homework_edit: false,
  // homework_delete: false,
  // homework_comment_display: false,
  // homework_comment_create: false,
  // homework_comment_edit: false,
  // homework_comment_delete: false,
  // test_input: false,
  // test_score_area_display_all: false,
  // test_score_area_display_part: false,
  // approve: false,
  //
  user_view_all: false,
  user_view_only: false,
  user_create: false,
  user_edit: false,
  user_delete: false,
  department_edit: false,
  department_delete: false,
  department_create: false,
  group_permission_view_all: false,
  group_permission_view_only: false,
  group_permission_edit: false,
  group_permission_delete: false,
  group_permission_create: false,
  sale_agency_edit: false,
  sale_agency_delete: false,
  sale_agency_create: false,
  work_office_view_all: false,
  work_office_create: false,
  work_office_edit: false,
  work_office_delete: false,
  employee_view_all: false,
  employee_view_only: false,
  employee_view_only_ta: false,
  employee_view_only_class: false,
  employee_edit: false,
  employee_delete: false,
  employee_create: false,
  teacher_view_all: false,
  teacher_view_schedule: false,
  teacher_view_available: false,
  kpi_view_all: false,
  kpi_create: false,
  kpi_edit: false,
  kpi_delete: false,
  product_create: false,
  product_delete: false,
  product_edit: false,
  shift_edit: false,
  shift_delete: false,
  shift_create: false,
  supply_edit: false,
  supply_delete: false,
  supply_create: false,
  activity_result_create: false,
  activity_result_edit: false,
  activity_result_delete: false,
  activity_type_create: false,
  activity_type_edit: false,
  activity_type_delete: false,
  product_type_create: false,
  product_type_edit: false,
  product_type_delete: false,
  lead_source_create: false,
  lead_source_edit: false,
  lead_source_delete: false,
  contact_source_create: false,
  contact_source_edit: false,
  contact_source_delete: false,
  class_view_all: false,
  class_view_available: false,
  class_view_schedule: false,
  discount_reason_create: false,
  discount_reason_edit: false,
  discount_reason_delete: false,
  account_view_all: false,
  account_view_only: false,
  account_create: false,
  account_view_phone: false,
  account_edit: false,
  contract_view_only: false,
  contract_view_class: false,
  contract_view_student: false,
  contract_view_product: false,
  contract_quit: false,
  contract_view_reserve: false,
  contract_edit_supply: false,
  contract_adjust_class: false,
  contract_rejoin: false,
  lead_view_all: false,
  lead_create_contract: false,
  lead_view_only: false,
  lead_create: false,
  lead_edit: false,
  lead_delete: false,
  payment_view_all: false,
  payment_create: false,
  payment_edit: false,
  receipt_view_all: false,
  receipt_create: false,
  receipt_edit: false,
  lead_activity_view_all: false,
  lead_activity_view_only: false,
  lead_activity_create: false,
  lead_activity_edit: false,
  lead_activity_delete: false,
  request_view_all: false,
  request_edit: false,
  account_history_view_all: false,
  contract_history_view_all: false,
  lead_history_view_all: false,
  class_score_create: false,
  class_score_edit: false,
  class_score_delete: false,
  section_view_all: false,
  section_create: false,
  section_edit: false,
  section_view_today: false,
  attendance_view_class: false,
  attendance_view_section: false,
  attendance_view_attend: false,
  student_score_view_all: false,
  student_score_edit_student: false,
  student_score_edit_score_student: false,
  contract_view_all: false,
  contract_create: false,
  contract_edit: false,
  class_create: false,
  class_edit: false,
  class_delete: false,
  attendance_edit: false,
  class_view_only: false,
  business_revenue_view_all: false,
  business_revenue_view_only: false,
  employee_revenue_view_all: false,
  employee_revenue_view_only: false,
  contact_transaction_status_view_all: false,
  contact_transaction_status_view_only: false,
  contact_gender_view_all: false,
  contact_gender_view_only: false,
  contact_location_view_all: false,
  contact_location_view_only: false,
  contact_date_of_birth_view_all: false,
  contact_date_of_birth_view_only: false,
  contact_source_report_view_all: false,
  contact_source_report_view_only: false,
  contact_product_view_all: false,
  contact_product_view_only: false,
  daily_schedule_view_all: false,
  daily_schedule_view_only: false,
  teacher_schedule_view_all: false,
  teacher_schedule_view_only: false,
  classroom_schedule_view_all: false,
  classroom_schedule_view_only: false,
  attendance_rate_view_all: false,
  attendance_rate_view_only: false,
  product_note_create: false,
  product_note_edit: false,
  product_note_delete: false,
  classroom_create: false,
  classroom_edit: false,
  classroom_delete: false,
  kpi_view_only: false,
};
